module.exports = __webpack_public_path__ + "/hashedassets-launcher/unsupported_browser.ee289c4c6f0df712ab31d9fc89d33211.svg";